import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

export default function AuditProperties({ props }) {
  const mapData = prop => {
    return (
      <Grid
        item
        container
        xs={12}
        sm={12}
        className="info-wrapper"
        style={{ paddingLeft: '10px' }}
        key={`propertykey_${prop.propertyName}`}
      >
        <Grid item xs={6} sm={6}>
          {prop.propertyName}
        </Grid>
        <Grid item xs={3} sm={3} className="overflow-wrap-item">
          {prop.oldValue || '-'}
        </Grid>
        <Grid item xs={3} sm={3} className="overflow-wrap-item">
          {prop.newValue || '-'}
        </Grid>
      </Grid>
    );
  };

  return (
    <React.Fragment>
      <div className="clinician-info-box" style={{ width: '100%' }}>
        <Typography variant="h6" gutterBottom>
          Audited Properties
        </Typography>
        <div className="activities-table-wrapper">
          <div className="activities-table-head">
            <Grid container>
              <Grid item xs={6} sm={6}>
                <p>Property Name</p>
              </Grid>
              <Grid item xs={3} sm={3}>
                <p>Old value</p>
              </Grid>
              <Grid item xs={3} sm={3}>
                <p>New value</p>
              </Grid>
            </Grid>
          </div>
          <div className="content">
            {props !== null && (
              <Box>
                <Grid container spacing={0}>
                  {props.map(mapData)}
                </Grid>
              </Box>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
